import timanttiService from "./timanttiService";
import bookingService from "./bookingService";
import {
    TimeslotResponse, Premise, EntityResponse, Building, PopulatedTimeslot,
    CampaignService
} from "../types";

const getTimeslot = async (
    uuid: string,
    services: CampaignService[]
): Promise<PopulatedTimeslot|null> => {
    const appointment: TimeslotResponse|null = await bookingService.fetchOpenAppointment(uuid);
    if (!appointment) return null;

    const toimipaikkaUuid = appointment.toimipaikka;

    const [expert, locationResponse] = await Promise.all([
        timanttiService.getExpert(appointment.työntekijä),
        timanttiService.getPremise(appointment.toimipaikka)
    ]);

    const location: Premise = locationResponse.data;

    const buildingResponse: EntityResponse<Building> = await timanttiService.getBuilding(
        location.toimitila);

    const service = services.find(service => service.uuid === appointment.palvelu);

    return {
        ...appointment,
        työntekijä: expert,
        toimipaikka: location,
        toimitila: buildingResponse.data,
        palvelunNimi: service?.name || '',
        toimipaikkaUuid,
        toimitilaUuid: location.toimitila
    };
};

export default {
    getTimeslot
};